<template>
  <div>
    <p v-if="type === 'MX'">
      <b :class="{ 'grey--text text--darken-4': !model.domain }">{{ model.domain || 'Name' }}</b> will point to
      <b :class="{ 'grey--text text--darken-4': !model.exchanger }">{{ model.exchanger || 'Destination' }}</b>
    </p>
    <p v-else-if="type === 'A' || type === 'AAAA'">
      <b :class="{ 'grey--text text--darken-4': !model.name }">{{ model.name || 'Name' }}.{{ domain }}</b> will point to
      <b :class="{ 'grey--text text--darken-4': !model.address }">{{ model.address || 'IP Address' }}</b>
    </p>
    <p v-else-if="type === 'CNAME'">
      <b :class="{ 'grey--text text--darken-4': !model.name }">{{ model.name || 'Name' }}.{{ domain }}</b> will point to
      <b :class="{ 'grey--text text--darken-4': !model.cname }">{{ model.cname || 'Canonical Name' }}</b>
    </p>
  </div>
</template>

<script>
export default {
  name: 'RecordHint',
  props: {
    type: {
      type: String,
      required: true
    },
    domain: {
      type: String,
      required: true
    },
    model: {
      type: Object,
      required: true
    }
  }
}
</script>
